import React, { useState } from "react";
import { useInput } from "../hook/useInput";
import { Button, Form, Row, Col } from "react-bootstrap";
import FloatingLabelInput from "../floatingLabelInput/FloatingLabelInput";
import { FaShieldAlt, FaLock } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import ToastMessage from "../modules/ToastMessage";
import "../styles/Login.css";

const Login = (props) => {
  const [user_name, bindUserName] = useInput();
  const [user_password, bindUserPassword] = useInput();
  const [invalidUser, setInvalidUser] = useState("");
  const [invalidPassword, setInvalidPassword] = useState("");
  const [disable, setDisable] = useState(false);
  const [showToast, setShowToast] = useState({
    flag: false,
    message: "",
    bg: "danger",
  });

  const errorHandle = (id, borderColor) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.borderColor = borderColor;
    }
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setDisable(true);
    const res = await props.onLogin({ user_email: user_name, user_password });
    if (res) {
      if (res.error) {
        if (res.error === "account inactive") {
          setShowToast({
            flag: true,
            message: "Your account is inactive.",
            bg: "danger",
          });
        } else if (res.error === "invalid user") {
          errorHandle("username", "red");
          setInvalidUser("Invalid user");
          setShowToast({
            flag: true,
            message: "Invalid user. Please check your username.",
            bg: "danger",
          });
        } else if (res.error === "incorrect password") {
          errorHandle("password", "red");
          setInvalidPassword("Enter a valid password");
          setShowToast({
            flag: true,
            message: "Incorrect password. Please try again.",
            bg: "danger",
          });
        }
        setDisable(false);
      } else if (res.user_id) {
        localStorage.setItem("user_id", res.user_id);
        localStorage.setItem("user_role", res.user_role);
      }
    } else {
      setDisable(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center w-100 min-vh-100 p-3 bg-light">
      <ToastMessage showToast={showToast} setShowToast={setShowToast} />
      <div className="erp-auth-wrapper">
        <Row className="g-0">
          <Col md={6}>
            <div className="erp-auth-hero">
              <div>
                <div className="d-flex align-items-center gap-2 mb-4">
                  <img
                    src="/images/Logo1.png"
                    alt="Soochi Logo"
                    style={{ height: "38px", width: "auto", objectFit: "contain" }}
                  />
                  <span className="fs-4 fw-bold text-white tracking-tight">
                    SOOCHI 
                  </span>
                </div>
                <h2 className="erp-auth-hero-title">
                  Enterprise Operations & Management
                </h2>
                <p className="erp-auth-hero-desc">
                  Streamline sales, billing, inventory control, and financial reporting with real-time business intelligence.
                </p>
              </div>

              <div className="d-flex align-items-center gap-3 pt-4 border-top border-white-50">
                <div className="p-2 rounded-3 bg-white text-primary">
                  <FaShieldAlt size={20} />
                </div>
                <div>
                  <div className="fw-semibold text-white small">Enterprise SSL Security</div>
                  <div className="text-white-50 small">256-bit encrypted authentication</div>
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="erp-auth-form-container">
              <h3 className="erp-auth-title">Sign In</h3>
              <p className="erp-auth-subtitle">
                Enter your credentials to access your organization workspace.
              </p>

              <Form onSubmit={onLogin}>
                <div className="mb-3">
                  <FloatingLabelInput
                    label="Email Address or Username"
                    type="text"
                    id="username"
                    {...bindUserName}
                    required
                    autoComplete="on"
                    onClick={() => {
                      errorHandle("username", "initial");
                      setInvalidUser("");
                    }}
                  />
                  {invalidUser && (
                    <div className="text-danger small mt-1">{invalidUser}</div>
                  )}
                </div>

                <div className="mb-3">
                  <FloatingLabelInput
                    label="Password"
                    type="password"
                    id="password"
                    required
                    {...bindUserPassword}
                    autoComplete="on"
                    onClick={() => {
                      errorHandle("password", "initial");
                      setInvalidPassword("");
                    }}
                  />
                  {invalidPassword && (
                    <div className="text-danger small mt-1">{invalidPassword}</div>
                  )}
                </div>

                <Button
                  type="submit"
                  disabled={disable}
                  className="erp-auth-btn d-flex align-items-center justify-content-center gap-2"
                >
                  <FaLock size={13} /> Sign In to Portal
                </Button>
              </Form>

              <div className="mt-4 text-center text-muted small">
                Don't have an account?{" "}
                <NavLink to="/signup" className="fw-bold text-primary text-decoration-none">
                  Create Account
                </NavLink>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Login;
